
document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more');
  const container = document.getElementById('block-new-articles-grid');
  if (!loadMoreBtn) return;
  loadMoreBtn.addEventListener('click', function () {
    const nextUrl = loadMoreBtn.getAttribute('data-next-url');
    if (!nextUrl) return;
    fetch(nextUrl)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const newArticles = doc.querySelectorAll('#block-new-articles-grid > *');
        const nextButton = doc.querySelector('#load-more');
        newArticles.forEach(article => {
          container.appendChild(article);
        });
        if (nextButton) {
          loadMoreBtn.setAttribute('data-next-url', nextButton.getAttribute('data-next-url'));
        } else {
          loadMoreBtn.remove();
        }
      })
      .catch(error => {
        console.error('Error loading more articles:', error);
      });
  });
});
